import AmexPlatinumReservationButtonListRefresh from './AmexPlatinumReservationButtonListRefresh';

export default AmexPlatinumReservationButtonListRefresh;
